import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { ChipsInputComponent } from '@shared/components/chips-input/chips-input.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-chips',
	imports: [SharedModule, ChipComponent, ChipsInputComponent, UiCodeBlockComponent],
	templateUrl: './ui-chips.component.html',
	styleUrl: './ui-chips.component.scss',
})
export class UiChipsComponent {
	@Input() chipsControl!: FormControl;
	@Input() disabledChipsControl!: FormControl;
	@Input() errorChipsControl!: FormControl;

	generateCode(attrs: {
		component: string;
		formControl?: string;
		label?: string;
		placeholder?: string;
		size?: string;
		disabled?: boolean;
		removable?: boolean;
		error?: boolean;
		errorMessage?: string;
	}): string {
		let code = '';

		if (attrs.component === 'chip') {
			code = '<app-chip\n';
			if (attrs.label) code += `    label="${attrs.label}"\n`;
			if (attrs.size) code += `    size="${attrs.size}"\n`;
			if (attrs.removable !== undefined) code += `    [removable]="${attrs.removable}"\n`;
			code += '/>';
		} else if (attrs.component === 'chips-input') {
			code = '<app-chips-input\n';
			if (attrs.formControl) code += `    [formControl]="${attrs.formControl}"\n`;
			if (attrs.placeholder) code += `    placeholder="${attrs.placeholder}"\n`;
			if (attrs.label) code += `    label="${attrs.label}"\n`;
			if (attrs.disabled) code += `    [disabled]="true"\n`;
			if (attrs.error) code += `    [error]="true"\n`;
			if (attrs.errorMessage) code += `    errorMessage="${attrs.errorMessage}"\n`;
			code += '/>';
		}

		return code;
	}
}
